import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SvgIcon from '../svg-icon/svg-icon';
import { Cell, ConversationStatus, Circle } from './styled';
import {
  getStatus,
  CORRECT,
  INCORRECT,
  UNATTEMPTED,
  SCHEDULED_ASSIGN
} from './utils';
import { Cross, Tick, NoAttempt, Clock } from '../../helpers/icon-dictionary';
import { studentStatus as status, getContextCoords } from '../../helpers/utils';
import ContextModal, { ContextModalWidth } from '../context-modal';

const StatusCell = (props) => {
  const { studentInfo, teacherStatus, id, isSelected, isFirstOfStatus, showSchedule, i18n } = props;
  const { studentStatus, startDateTime, finishDateTime } = studentInfo;
  const cellStatus = getStatus(studentStatus);
  const [showCallOutMenu, setCallOutMenu] = useState(false);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionYCallout, setPositionYCallout] = useState(0);
  const [positionArrowCallout, setPositionArrowCallout] = useState(0);
  const [contextTheme, setContextTheme] = useState(null);
  const infoRef = useRef(null);

  const statusIcons = {
    [CORRECT]: Tick,
    [INCORRECT]: Cross,
    [UNATTEMPTED]: NoAttempt,
    [SCHEDULED_ASSIGN]: Clock
  };

  const showCallOut = () => {
    const { posX, posY, posArrow } =
      getContextCoords(infoRef.current.getBoundingClientRect(), ContextModalWidth);
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOutMenu(true);
  };

  const hideCallOut = () => {
    setCallOutMenu(false);
  };
  return (
    <Cell
      id={id}
      status={cellStatus}
      teacherStatus={teacherStatus}
      isSelected={isSelected}
      key={`${id}`}>
      {showSchedule ?
        <ConversationStatus
          key={`${teacherStatus} ${id}`}
          onMouseEnter={showCallOut}
          onMouseLeave={hideCallOut}
          ref={infoRef}>
          {cellStatus === SCHEDULED_ASSIGN && statusIcons[cellStatus] && isFirstOfStatus &&
            <SvgIcon icon={statusIcons[cellStatus]} />
          }
          {
            cellStatus === SCHEDULED_ASSIGN && !isFirstOfStatus &&
            <Circle />
          }
          <ContextModal
            show={showCallOutMenu}
            positionArrow={positionArrowCallout}
            positionX={positionXCallout}
            positionY={positionYCallout}
            contextTheme={contextTheme}
            unrestrictedWidth
            name={`${i18n.t`Period`}: 
              ${moment(startDateTime).format('h:mma (DD.MM.YYYY)')} - 
              ${moment(finishDateTime).format('h:mma (DD.MM.YYYY)')}`
            }
          />
        </ConversationStatus> :
        <ConversationStatus key={`${teacherStatus} ${id}`}>
          {(cellStatus === CORRECT || cellStatus === INCORRECT || cellStatus === UNATTEMPTED) &&
            <SvgIcon icon={statusIcons[cellStatus]} />
          }
        </ConversationStatus>}
    </Cell>
  );
};

StatusCell.propTypes = {
  studentInfo: PropTypes.object,
  teacherStatus: PropTypes.number,
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  isFirstOfStatus: PropTypes.bool,
  showSchedule: PropTypes.bool,
  i18n: PropTypes.object
};

StatusCell.defaultProps = {
  studentInfo: {
    studentStatus: status.UNASSIGNED,
    stepsCount: 0,
    stepsCompleted: 0,
    assignmentId: -1
  }
};

export default StatusCell;
